var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFlame = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16865",
    "data-name": "Rectangle 16865",
    width: 8.994,
    height: 12.977,
    transform: "translate(0 0)",
    fill: "#959cf2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flame-blue",
    transform: "translate(11884 -8179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16863",
    "data-name": "Rectangle 16863",
    width: 16,
    height: 16,
    transform: "translate(-11884 8179)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10139",
    "data-name": "Group 10139",
    transform: "translate(-11880.496 8180.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10138",
    "data-name": "Group 10138",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M8.624,10.078a5.077,5.077,0,0,1-2.754,2.737,6.14,6.14,0,0,1-2.638.042.125.125,0,0,1-.023,0,.237.237,0,0,1-.033,0,2.771,2.771,0,0,1-.33-.077.088.088,0,0,1-.019-.006,4.2,4.2,0,0,1-2.1-1.594C-.525,9.587.052,7.492.853,5.841l.058.016q.08,1.241.161,2.485c.014-.009.034-.016.042-.03.355-.569.749-1.118,1.053-1.714A17.629,17.629,0,0,0,3.7.419v-.4L3.729,0c.066.111.133.222.2.335A20.165,20.165,0,0,1,5.949,4.207a7.762,7.762,0,0,1,.565,2.16.979.979,0,0,0,.17-.119c.084-.088.152-.192.238-.278A5.373,5.373,0,0,0,8.073,3.784a1.423,1.423,0,0,1,.135.2,13.008,13.008,0,0,1,.546,1.431,8.226,8.226,0,0,1-.129,4.664",
    transform: "translate(0 -0.001)",
    fill: "#959cf2"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlame, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flame.9edca333.svg";
export { ForwardRef as ReactComponent };